export default {
  branding: {
    productName: "CrazyBuzzer",
    companyName: "ULTRA BUZZ GmbH",
    companyAbbr: "UB",
    companyStreet: "Merkur Allee 1-15",
    companyCity: "32339 Espelkamp",
    companyMail: "marketing@crazybuzzer.com",
    companySupportMail: "support@crazybuzzer.com",
    companyPrivacyMail: "marketing@crazybuzzer.com",
    companyPhone: "+49 1520 4235954",
    companyPhoneEn: "+49 1520 4235954",
    companyPhoneDe: "+49 1520 4235954",
    companyCEO: "Maximilian Schwier",
    companyCEO2: "Alexander Knopf",
    companyUrl: "https://crazybuzzer.com",
    productUrl: "crazybuzzer.com",
    startingYear: "2025",
    companyPrivacyUrl: process.env.VUE_APP_HOST + "/privacy",
    googlePlayUrl:
      "https://play.google.com/store/apps/details?id=com.crazybuzzer.app",
    appStoreUrl: "http://itunes.apple.com/app/id6745273513",
    previewImage: process.env.VUE_APP_HOST + "/preview.png",
    title: "meta.title",
    description: "meta.description",
    seoDefaultDescription: "meta.description",
  },
  currencies: {
    primary: {
      single: require("@/assets/img/common/coin1.png"),
      large: require("@/assets/img/common/coin1.png"),
      accent: require("@/assets/img/common/coin.png"),
      triple: require("@/assets/img/common/three-coins.png"),
      heap: require("@/assets/img/common/heap-of-gold.png"),
    },
    secondary: {
      single: require("@/assets/img/common/buzzer_gem.png"),
      large: require("@/assets/img/common/buzzer_gem_big.png"),
      accent: require("@/assets/img/common/buzzer_gem.png"),
      triple: require("@/assets/img/common/three-gems.png"),
    },
    tertiary: {
      single: require("@/assets/img/common/elixir.png"),
    },
  },
  assets: {
    logos: {
      small: require("@/assets/img/logo/buzzer_logo_blue_sm.png"),
      large: require("@/assets/img/logo/buzzer_logo_blue_lg.png"),
      accent: null,
      monochrome: require("@/assets/img/logo/buzzer_logo_blue_sm.png"),
      slotPlaceholder: require("@/assets/img/game/placeholder.png"),
      homeButton: null,
      logoutIcon: require("@/assets/img/settings/icon-logout.svg"),
      newsletterVisual: require("@/assets/img/profile/newsletter-visual.png"),
      hoverlogo: require("@/assets/img/logo/buzzer_logo_blue_sm.png"),
    },

    features: {
      loyalty: {
        icon: require("@/assets/img/common/loyalty.png"),
        accent: require("@/assets/img/common/loyalty-bonus.png"),
      },
      league: {
        icon: require("@/assets/img/nav-menu/nav-icon-league.png"),
        hero: {
          en: require("@/assets/img/hero-images/hero-pic-feature-royalleague-default_en.png"),
          de: require("@/assets/img/hero-images/hero-pic-feature-royalleague-default_de.png"),
        },
        logo: {
          en: require("@/assets/img/hero-images/royalleague-hero-logo-en.png"),
          de: require("@/assets/img/hero-images/royalleague-hero-logo-de.png"),
        },
      },
      retention: {
        icon: require("@/assets/img/nav-menu/nav-icon-bonusslot.png"),
        headlineOff: require("@/assets/img/bonus-slot/bs-main-hl-normal.png"),
        headlineOn: require("@/assets/img/bonus-slot/bs-main-hl-glow.png"),
        coinDeco1: null,
        coinDeco2: null,
        crownDeco: null,
      },
      cards: {
        icon: require("@/assets/img/common/cardstack-3.png"),
        triple: require("@/assets/img/nav-menu/nav-icon-cards.png"),
        accent: require("@/assets/img/common/cards.png"),
        small: require("@/assets/img/common/card.png"),
        hero: require("@/assets/img/hero-images/hero-pic-feature-cards-default.jpg"),
      },
      achievements: {
        icon: require("@/assets/img/nav-menu/nav-icon-achievements.png"),
      },
      pvp: {
        icon: require("@/assets/img/nav-menu/nav-icon-champions.png"),
        hero: require("@/assets/img/hero-images/hero-pic-feature-champions-default.png"),
        logo: require("@/assets/img/champions/champions-logo.png"),
      },
      social: {
        icon: require("@/assets/img/nav-menu/nav-icon-friends.png"),
        hero: {
          de: require("@/assets/img/hero-images/hero-pic-feature-friends-de.png"),
          en: require("@/assets/img/hero-images/hero-pic-feature-friends-en.png"),
          teams: require("@/assets/img/hero-images/hero-pic-feature-teams.png"),
        },
        vaultVisual: require("@/assets/img/friends/goldfellowship.png"),
      },
      path: {
        icon: require("@/assets/img/nav-menu/nav-icon-kingspath.png"),
      },
      mission: {
        icon: require("@/assets/img/mission/chests/chest-5-king.png"),
        goldDisplay: require("@/assets/img/common/gold-display.png"),
      },
      tournament: {
        icon: require("@/assets/img/nav-menu/nav-icon-tournaments.png"),
        endIcon: require("@/assets/img/slot/sidebar/tourney-end-checkmark.png"),
        hero: {
          en: require("@/assets/img/hero-images/hero-logo-tourney-en.png"),
          de: require("@/assets/img/hero-images/hero-logo-tourney-de.png"),
        },
      },
      profile: {
        hero: require("@/assets/img/hero-images/hero-pic-profile.png"),
      },
      booster: {
        icon: require("@/assets/img/common/booster.png"),
      },
      treasury: {
        goldDisplay: require("@/assets/img/common/gold-display.png"),
      },
      shop: {
        visual: require("@/assets/img/shop/shop-visual-default.png"),
        icon: require("@/assets/img/header/button-shop.png"),
      },
    },
    events: {
      spin: {
        coinVisual: require("@/assets/img/events/frame-with-coin.png"),
      },
    },
    offers: {
      lobby3: {
        de: require("@/assets/img/shop/offers/offer-overlay-jetztodernie_unbranded_de.png"),
        en: require("@/assets/img/shop/offers/offer-overlay-jetztodernie_unbranded_en.png"),
      },
      winterhere1: {
        de: require("@/assets/img/shop/offers/winterda-logo-de.png"),
        en: require("@/assets/img/shop/offers/winterda-logo-en.png"),
      },
      winter1: {
        de: require("@/assets/img/shop/offers/dwn-logo-de.png"),
        en: require("@/assets/img/shop/offers/dwn-logo-en.png"),
      },
      autumn: {
        de: require("@/assets/img/shop/offers/autumn-logo-de.png"),
        en: require("@/assets/img/shop/offers/autumn-logo-en.png"),
      },
      specialOffer: {
        onePanel: require("@/assets/img/shop/offers/special-1.png"),
        twoPanels: require("@/assets/img/shop/offers/special-2.png"),
      },
      newUserOffer: {
        //de: require(`@/assets/img/shop/offers/offer-overlay-lobby-jetztodernie-3-panels_de.png`),
        //en: require(`@/assets/img/shop/offers/offer-overlay-lobby-jetztodernie-3-panels_en.png`),
      },
      starter1: {
        headline: {
          de: require("@/assets/img/shop/offers/headline-starterpaket-de.png"),
          en: require("@/assets/img/shop/offers/headline-starterpaket-en.png"),
        },
        background: require("@/assets/img/shop/offers/meinekrone-offer-overlay-starterpaket.png"),
      },
      bailout: {
        primary: {
          onePanel: require("@/assets/img/shop/offers/bailout-primary-1.png"),
          twoPanels: require("@/assets/img/shop/offers/bailout-primary-2.png"),
          threePanels: require("@/assets/img/shop/offers/bailout-primary-3.png"),
        },
        secondary: {
          onePanel: require("@/assets/img/shop/offers/bailout-secondary-1.png"),
          twoPanels: require("@/assets/img/shop/offers/bailout-secondary-2.png"),
          threePanels: require("@/assets/img/shop/offers/bailout-secondary-3.png"),
        },
      },
      levelup: {
        onePanel: require("@/assets/img/shop/offers/levelup-1.png"),
        twoPanels: require("@/assets/img/shop/offers/levelup-2.png"),
        threePanels: require("@/assets/img/shop/offers/levelup-3.png"),
      },
      moreContentBadge: require("@/assets/img/shop/offers/badge-big-back5.png"),
    },
    modals: {
      welcome: {
        de: require("@/assets/img/welcome/welcome-bg-de.png"),
        en: require("@/assets/img/welcome/welcome-bg-en.png"),
      },
    },
  },
  featuresEnabled: {
    paypal_payment: false,
    paypal_login: true,
    facebook: true,
    google: true,
    apple: false,
    team: false,
    chat: false,
    swapStack: false,
    slotProvider: false,
    checkbox: true,
    dataLayerTracking: true,
    hotjar: false,
    v2Offers: true,
    NewsPopup: false,
    multilog24: true,
    seasonPass: true,
    offerChain: true,
    explainers: true,
    otpAuth: true,
  },
  cardProbabilities: ["legendary", "epic", "rare", "uncommon", "common"],
};
